import React, { useState, useEffect } from "react";
import ViewHeader from "../viewHeader/viewHeader";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import apiService from "../../utils/api";
import { useNavigate } from "react-router-dom";

const LabelConfig = () => {
  const navigate = useNavigate();
  const [labelWidth, setLabelWidth] = useState("");
  const [labelHeight, setLabelHeight] = useState("");
  const [configId, setConfigId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const authToken = sessionStorage.getItem("authToken");
        if (authToken) {
          const response = await apiService.getLabelConfig(authToken);
          const config = response.data;
          setConfigId(config.id);
          setLabelWidth(config.labelWidth);
          setLabelHeight(config.labelHeight);
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Error fetching label config:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchConfig();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const authToken = sessionStorage.getItem("authToken");
      const store = sessionStorage.getItem("store");
      if (authToken) {
        await apiService.updateLabelConfig(authToken, configId, labelWidth, labelHeight, store);
        navigate("/settings");
      } else {
        navigate("/");
      }
    } catch (error) {
      console.error("Error updating label config:", error);
    }
  };

  if (loading) return null;

  return (
    <Container>
      <ViewHeader screenName={"Label Configuration"} />
      <Container maxWidth="sm">
        <Box
          display="flex"
          flexDirection="column"
          component={"form"}
          className="custom-box"
          onSubmit={handleSubmit}
        >
          <TextField
            label="Label Width (cm)"
            variant="outlined"
            margin="normal"
            fullWidth
            required
            type="number"
            inputProps={{ step: "0.01", min: "0" }}
            value={labelWidth}
            onChange={(e) => setLabelWidth(e.target.value)}
          />
          <TextField
            label="Label Height (cm)"
            variant="outlined"
            margin="normal"
            fullWidth
            required
            type="number"
            inputProps={{ step: "0.01", min: "0" }}
            value={labelHeight}
            onChange={(e) => setLabelHeight(e.target.value)}
          />
          <Typography variant="body2" color="textSecondary" sx={{ mt: 1, mb: 2 }}>
            Preview:
          </Typography>
          <Box display="flex" justifyContent="center" sx={{ mb: 3 }}>
            <Paper
              variant="outlined"
              style={{
                width: `${labelWidth}cm`,
                height: `${labelHeight}cm`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="caption" color="textSecondary">
                {labelWidth}cm x {labelHeight}cm
              </Typography>
            </Paper>
          </Box>
          <Button variant="contained" color="primary" fullWidth type="submit">
            Save
          </Button>
        </Box>
      </Container>
    </Container>
  );
};

export default LabelConfig;
